/*
 * @autor      Holger Schauf
 * @brief      controle manage and log all applications
 */
var mote = (function ($) {
    return {

        // storage
        data: {},

        lang: document.documentElement.lang,

        mode: {
            debug: false,
            intern: false,
            record: false
        },

        storage: {
            applications: {},
            templates: {},
            trackings: {}
        },

        /**
         *
         * @returns {*}
         */
        register: function (name) {

            var d = name.split('.'),
                o = this,
                l = d.length;

            for (var j = d[0] === 'mote' ? 1 : 0; j < l; j++) {
                o[d[j]] = o[d[j]] || {};
                o = o[d[j]];
            }

            return o;
        },

        /**
         *
         * @param f = function
         * @param a = arguments
         * @returns {Function}
         */
        doLater: function (f, a) {
            var args = Array.prototype.slice.call(arguments, 2).sort();
            return function (e) {
                if (typeof e !== 'undefined') {
                    args.unshift(e);
                }

                return f.apply(a, args);
            };
        },

        /**
         * add / get value by key
         * @param k = key
         * @param v = value
         * @returns {*}
         */
        property: function (k, v) {

            // set value by key
            if (arguments.length > 1) {
                this.data[k] = v;
                return this.data[k];
            }

            // get value by key
            return this.data.hasOwnProperty(k) ? this.data[k] : false;
        },

        /*
         * get Window Dimension
         * @param true = object || false = sting
         */
        getWindowSize: function () {
            var asObject = arguments.length > 0 ? true : false;

            var object = {
                width: isNaN(window.innerWidth) ? window.clientWidth : window.innerWidth,
                height: isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight
            };

            var string = object.width + 'x' + object.height;

            return asObject === true ? object : string;
        },

        /**
         *
         * @param tpl
         * @param data
         * @returns {*}
         */
        getTemplate: function (tpl, data) {

            if (!this.storage.templates.hasOwnProperty(tpl)) {
                var tmpl = $.templates('#' + tpl);
                if (typeof tmpl === 'undefined') {
                    logo.add(
                        'error',
                        {
                            name: tpl,
                            error: 'template is not defined'
                        }
                    );
                    return false;
                }
                this.storage.templates[tpl] = $.templates('#' + tpl);
                $.templates('#' + tpl);
            }

            return this.storage.templates[tpl].render(data);
        },

        /**
         *
         * @returns {boolean}
         */
        isTouch: function () {
            return 'ontouchstart' in window || 'onmsgesturechange' in window;
        },

        /**
         *
         * @param string
         * @returns {{}}
         */
        decipher: function (string) {
            var object = {},
                l = string.length;
            for (var i = 0; i < l; i++) {
                var parts = string[i].split(':');
                object[parts[0]] = parts[1];
            }
            return object;
        }

    };
})(jQuery);
